import {IconButton} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import {openPatientForm} from '../../store/reducers/patientContext';
import {useDispatch, useSelector} from 'react-redux';
import {additionalData, patientHistoryData} from '../../store/reducers/additionalData';

const HistoryFormButton = ({openFormPath, disabled, isPatientAddData, multiplePath, setLoading}) => {
    const dispatch = useDispatch();

    // Selectors
    const ptHistData = useSelector(patientHistoryData);
    const patientAddData = useSelector(additionalData);

    const [showHistory, setShowHistory] = useState(false);

    useEffect(() => {
        let haveHistory = false;

        if (!isPatientAddData) {
            _.forEach(ptHistData, piw => {
                if (haveHistory) return;

                const getData = _.get(piw, multiplePath);
                const filtered = _.filter(getData, d => !d?.canceled);
                haveHistory = filtered?.length > 0;
            });
        } else {
            const data = _.get(patientAddData, multiplePath);
            const filtered = _.filter(data, d => !d?.status !== 'CANCELED');
            haveHistory = filtered?.length > 0;
        }
        setLoading(false);
        setShowHistory(haveHistory);
    }, [ptHistData]);

    const handleOpenHistoryList = () => {
        if (!disabled && openFormPath) {
            dispatch(openPatientForm(`$multi_${openFormPath}`));
        }
    };

    if (!showHistory) return null;

    return (
        <IconButton
            size="small"
            onClick={handleOpenHistoryList}
            className="disabled-options"
        >
            <HistoryIcon fontSize="small"/>
        </IconButton>
    );
};

export default HistoryFormButton;